import cx from "classnames";
import React from "react";
import PlusIcon from "../../../assets/plus";
import MinusIcon from "../../../assets/minusIcon";
import ExternalLink from "../../../assets/externalLink";
import SublimationSubMenu from "./SublimationSubMenu";
import { subMenuLinks } from "./data";

interface Props {
  jwtToken: string;
  expandedGroup: string;
  setExpandedGroup: React.Dispatch<React.SetStateAction<string>>;
  name: string;
}

const SublimationMenu = ({ jwtToken, expandedGroup, setExpandedGroup, name }: Props) => {
  const isExpanded = expandedGroup === name;
  const sublimationWebsite = process.env.REACT_APP_SUBLIMATION_WEBSITE || "";
  const primaryEntry = subMenuLinks.find((link) => link.title === "Design Your Way");

  const mainSiteUrl = primaryEntry
    ? primaryEntry.isExternalLink
      ? primaryEntry.targetLink
      : `${sublimationWebsite}${primaryEntry.targetLink}?jwt=${jwtToken}`
    : "";

  return (
    <div className={cx("bizcolab-module", { "bizcolab-module--expanded": isExpanded })}>
      <div className="bizcolab-module__summary">
        <div>
          <p className="bizcolab-module__subtitle">Biz Co.Lab</p>
          <p className="bizcolab-module__description">
            Browse the full range of fully customizable sublimation uniforms and design options.
          </p>
        </div>
        <div className="bizcolab-module__actions">
          {mainSiteUrl && (
            <a className="bizcolab-module__cta" href={mainSiteUrl} target="_blank" rel="noreferrer">
              Design Your Way
              <ExternalLink width={25} fill="white" />
            </a>
          )}
          <button
            type="button"
            className="bizcolab-module__toggle"
            onClick={() => {
              setExpandedGroup(isExpanded ? "" : name);
            }}
          >
            <span>{isExpanded ? "Hide Links" : "View Links"}</span>
            {isExpanded ? (
              <MinusIcon fill="white" width={10} />
            ) : (
              <PlusIcon fill="white" width={10} />
            )}
          </button>
        </div>
      </div>

      {isExpanded && (
        <div className="bizcolab-module__panel">
          <SublimationSubMenu jwt={jwtToken} />
        </div>
      )}
    </div>
  );
};

export default SublimationMenu;
